<template>
  <b-modal
      ref="send-sms"
      size="lg"
      :title="$t('title.messages.sms')"
  >
    <div v-if="message" class="row mt-3 mb-4">
      <div class="col-6 d-flex flex-column">
        <div>
          <span class="font-weight-bold mr-2">{{$t('message.sent_at')}}:</span>
          {{message.sentAt | dateTimeFormat}}
        </div>
      </div>
      <div class="col-6">{{ message.contents }}</div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group id="input-group-2" :label="$t('messages.email.topic')" label-for="topic">
          <b-form-input
              id="topic"
              v-model="topic"
              :placeholder="$t('messages.email.topic.placeholder')"
              :state="!$v.topic.$dirty ? null :(!$v.topic.$error)"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <b-form>
      <b-form-group
          :label="$t('messages.sms.content')"
          label-for="slug"
          class="mt-4"
      >
        <b-form-textarea
            id="textarea"
            v-model="content"
            :state="!$v.content.$dirty ? null :(!$v.content.$error)"
            :placeholder="$t('messages.sms.content_placeholder')"
            rows="3"
            style="overflow-y: auto"
            max-rows="6"
        ></b-form-textarea>
      </b-form-group>
    </b-form>

    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import alertify from "alertifyjs";

export default {
  props: {
    message: Object
  },
  data() {
    return {
      busy: false,
      topic: '',
      content: '',
    }
  },
  validations: {
    topic: {
      required
    },
    content: {
      required
    }
  },
  mounted() {
    this.openModal();
  },
  methods: {
    submit() {

      this.$v.$touch();

      const playerIdFromUrl = this.$route.params.id;

      const payload = {
        playerId: playerIdFromUrl,
        topic: this.topic,
        contents: this.content
      }

      if(!this.$v.$invalid) {
        this.$store.dispatch('players/sendSmsMessage', payload).then(() => {
          this.$parent.$emit('refreshGrid');
          this.hideModal();
        }).catch(() => {
          alertify.error(this.$t('messages.sms.error'));
        });
      }
    },
    openModal() {
      this.$refs['send-sms'].show();
    },
    hideModal() {
      this.$refs['send-sms'].hide();
    }
  }
}
</script>
